import React from 'react';
import { useDispatch } from 'react-redux';
import { PUSH_FAVOURITE } from '../../utils/actionTypes';
import useFlattenedFavourites from '../../globalHooks/useFlattenedFavourites';

const Favourite = ({ id, type, white, additionalClass = '' }) => {
  const dispatch = useDispatch();
  const flattenedFavourites = useFlattenedFavourites();

  const active = flattenedFavourites.includes(id);

  const getFavouriteType = (type) => {
    switch (type) {
      case 'holiday':
        return 'holidays';
      case 'accommodation':
        return 'accommodations';
      case 'thing_to_do':
        return 'activities';
      default:
        return null;
    }
  };

  const favourite = () =>
    dispatch({
      type: PUSH_FAVOURITE,
      payload: { id, context: getFavouriteType(type) },
    });

  return (
    <span
      className={(() => {
        let returner = `o-heart ${additionalClass}`;
        returner = white ? `${returner} o-heart--white` : returner;

        if (active) {
          returner = `${returner} ${
            white ? 'o-heart--white--active' : 'o-heart--active'
          }`;
        }

        return returner;
      })()}
      onClick={() => favourite()}
    >
      Add to wishlist
    </span>
  );
};

export default Favourite;
